import { MarkdownViewer } from "@expert/solve-tools";

import type { ExpertAssistMessage } from "../../shared-types";

import { SalesGuidance } from "../message-bubble/custom-messages/SalesGuidance";
import { SalesMessage } from "../message-bubble/custom-messages/SalesMessage";
import { generateSessionSummaryItem } from "../message-bubble/custom-messages/SessionSummary";
import { MessageTag } from "../timeline-item/elements";
import { Separator } from "../timeline-item/Separator";
import { timelineMarkdownOptions } from "./markdownOverrides";

export function generateTimelineItemFromType(message: ExpertAssistMessage) {
    switch (message.type) {
        case "Connection":
        case "Error":
        case "Expert":
        case "Default":
        case "QuickAction":
        case "Proactive":
        case "ProactiveGuidance":
        case "GuideRecommendation":
        case "Generic":
        case "Search":
        case "SmartOfferGeneric":
        case "SmartOfferResponse":
            return <MarkdownViewer content={message.text} options={timelineMarkdownOptions} />;
        case "SmartOffer":
            return (
                <>
                    {message.tag && <MessageTag tagName={message.tag} type="SmartOffer" />}
                    <MarkdownViewer content={message.text} options={timelineMarkdownOptions} />
                </>
            );
        case "SessionSummary": {
            const sessionSummary = message.metadata?.sessionSummary;
            return sessionSummary && generateSessionSummaryItem(sessionSummary);
        }
        case "SalesGuidance": {
            const salesGuidance = message.metadata?.salesGuidance;
            return salesGuidance && <SalesGuidance metadata={salesGuidance} />;
        }
        case "SalesMessage": {
            const salesMessage = message.metadata?.salesMessage;
            return salesMessage && <SalesMessage metadata={salesMessage} />;
        }
        case "Separator": {
            return <Separator label={message.text} />;
        }
    }
}
